import React from 'react';
import {
  Box,
  Typography,
  Chip,
  Paper,
} from '@mui/material';
import {
  Analytics,
  Block,
} from '@mui/icons-material';


// Declare gtag for TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

interface AnalyticsDebugProps {
  analyticsEnabled: boolean;
}

const AnalyticsDebug: React.FC<AnalyticsDebugProps> = ({ analyticsEnabled }) => {

  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const localStorageConsent = localStorage.getItem('analytics-consent');
  const localStorageTheme = localStorage.getItem('colorMode');

  return (
    <Box sx={{ position: 'fixed', bottom: 80, left: 24, zIndex: 1200 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 2, 
          minWidth: 300,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider'
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Analytics Debug
        </Typography>
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
            Current State:
          </Typography>
          <Chip
            icon={analyticsEnabled ? <Analytics /> : <Block />}
            label={analyticsEnabled ? 'Analytics Enabled' : 'Analytics Disabled'}
            color={analyticsEnabled ? 'success' : 'error'}
            size="small"
            sx={{ mb: 1 }}
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
            localStorage Values:
          </Typography>
          <Box sx={{ fontSize: '0.75rem', fontFamily: 'monospace' }}>
            <div>analytics-consent: "{localStorageConsent}"</div>
            <div>colorMode: "{localStorageTheme}"</div>
          </Box>
        </Box>

        <Box>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
            Test Instructions:
          </Typography>
          <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
            1. Change analytics consent
          </Typography>
          <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
            2. Reload the page (F5)
          </Typography>
          <Typography variant="caption" sx={{ display: 'block' }}>
            3. Check if settings persist
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default AnalyticsDebug; 